import useFilters from 'modules/core/components/DataTable/hooks/useFilters'

import { buildCardPaymentsInsightWidget } from 'modules/banking/components/Widgets/CardPaymentsWidget'
import { formattedAmount } from 'modules/banking/lib/paymentHelpers'
import { DataTableWidgetInsights } from 'modules/finance/components/Widgets/common/widgets'

interface AccountCardPaymentsInsightsProps {
  currency: string
  locale: string
  accountIds: number[]
  search: string
}

export const AccountCardPaymentsInsights = ({
  currency,
  locale,
  accountIds,
  search,
}: AccountCardPaymentsInsightsProps) => {
  const { getFiltersVariables } = useFilters()

  const amountFormatter = (value: unknown) =>
    Number(value) ? formattedAmount({ amountCents: Number(value), currency, locale: locale }) : ''
  const dataTableFilters = getFiltersVariables().filter ?? {}

  return (
    <DataTableWidgetInsights
      widgets={[
        buildCardPaymentsInsightWidget({
          queryArgs: { accountIds, search },
          filters: dataTableFilters,
          prepareDataArgs: { amountFormatter },
        }),
      ]}
      widgetWidth="full"
    />
  )
}
